import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { environment } from "../environment/environments";

const apiRoute = "/api/";

let token = "";
let programId = "710c3197-3937-43c9-8c15-ef1d465a00a8";

const setTokenValues = () => {
  token = `user ${localStorage.getItem("token")}`;
}

export const getAllPrograms = createAsyncThunk(
  "admin/getAllPrograms",
  async (thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "getAllPrograms",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getProgramDetails = createAsyncThunk(
  "admin/getProgramDetails",
  async ({programId, search}, thunkAPI) => {
    try {
      setTokenValues();
      const title = search ?? "";
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/" +
          programId +
          `/getProgramDetails?title=${title}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// export const getDashboardData = createAsyncThunk(
//   "admin/getDashboardData",
//   async (thunkAPI) => {
//     try {
//       setTokenValues();
//       const response = await fetch(
//           environment.baseURL + 
//           apiRoute +
//           `/getDashboardData`,
//         {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: token
//           },
//         }
//       );
//       let data = await response.json();
      
//       if (response.status === 200) {
//         return data.Data;
//       } else {
//         return thunkAPI.rejectWithValue(data);
//       }
//     } catch (e) {
//       thunkAPI.rejectWithValue(e.response.data);
//     }
//   }
// );

export const getAllMentors = createAsyncThunk(
  "admin/getAllMentors",
  async ({search, user, program, index, company}, thunkAPI) => {
    try {
      setTokenValues();
      const title = search ?? "";
      const programId = program ?? "";
      const page = index ?? "";
      const work = company ?? "";

      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          `/getAllUsers/mentor?title=${title}&pid=${programId}&page=${page}&work=${work}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllMentees = createAsyncThunk(
  "admin/getAllMentees",
  async ({search, user, qualification, index, company}, thunkAPI) => {
    try {
      setTokenValues();
      const title = search ?? "";
      const type = qualification ?? "";
      const page = index ?? "";
      const work = company ?? "";

      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          `/getAllUsers/mentee?title=${title}&type=${type}&page=${page}&work=${work}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getParticularUser = createAsyncThunk(
  "admin/getParticularUser",
  async ({user, userId}, thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/getParticularUser/" + 
          user + 
          "/" + 
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  "admin/updateUserDetails",
  async (obj ,thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/updateUserDetails",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
          body: JSON.stringify(obj)
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateSpecificUser = createAsyncThunk(
  "admin/updateSpecificUser",
  async ({userId, obj} ,thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/" +
          userId +
          "/updateSpecificUser",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
          body: JSON.stringify(obj)
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const addProgramAndUsers = createAsyncThunk(
  "admin/addProgramAndUsers",
  async (obj ,thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/addProgramAndUsers",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
          body: JSON.stringify(obj)
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const addUser = createAsyncThunk(
  "admin/addUser",
  async ({user, obj} ,thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "addUser/" +
          user,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
          body: JSON.stringify(obj)
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllUpcomingCalls = createAsyncThunk("admin/getAllUpcomingCalls", async ({search, date, program, index},thunkAPI) => {
  try {
      setTokenValues();
      const title = search ?? "";
      const ate = date ?? "";
      const pid = program ?? "";
      const page = index ?? "";

      const response = await fetch(environment.baseURL +
          apiRoute +
          programId +
          `/getAllUpcomingCalls?title=${title}&pid=${pid}&ate=${ate}&page=${page}`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getAllPastCalls = createAsyncThunk("admin/getAllPastCalls", async ({search, date, program, status, index},thunkAPI) => {
  try {
      setTokenValues();
      const title = search ?? "";
      const ate = date ?? "";
      const pid = program ?? "";
      const ss = status ?? "";
      const page = index ?? "";

      const response = await fetch(environment.baseURL +
          apiRoute +
          programId +
          `/getAllPastCalls?title=${title}&pid=${pid}&ate=${ate}&ss=${ss}&page=${page}`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getAllOngoingCalls = createAsyncThunk("admin/getAllOngoingCalls", async ({search, date, program, status, index},thunkAPI) => {
  try {
      setTokenValues();
      const title = search ?? "";
      const ate = date ?? "";
      const pid = program ?? "";
      const ss = status ?? "";
      const page = index ?? "";

      const response = await fetch(environment.baseURL +
          apiRoute +
          programId +
          `/getAllOngoingCalls?title=${title}&pid=${pid}&ate=${ate}&ss=${ss}&page=${page}`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getUpcomingInterviewDetails = createAsyncThunk("admin/getUpcomingInterviewDetails", async ({user, userId, status, index, date, search} ,thunkAPI) => {
  try {
      setTokenValues();

      const ss = status ?? "";
      const page = index?? "";
      const ate = date ?? "";
      const title = search ?? "";

      const response = await fetch(environment.baseURL +
          apiRoute +
          "/" +
          userId + 
          `/getUpcomingInterviewDetails/` +
          user + `?ss=${ss}&page=${page}&ate=${ate}&title=${title}`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      if (response.statusText === 'Unauthorized') {
          localStorage.clear();
          window.location.reload();
      }
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getPastInterviewDetails = createAsyncThunk("admin/getPastInterviewDetails", async ({user, userId, status, index, date, search} ,thunkAPI) => {
  try {
      setTokenValues();

    const ss = status ?? "";
    const page = index ?? "";
    const ate = date ?? "";
    const title = search ?? "";

      const response = await fetch(environment.baseURL +
          apiRoute +
          "/" +
          userId + 
          `/getPastInterviewDetails/` +
          user + `?ss=${ss}&page=${page}&ate=${ate}&title=${title}`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getOrgCreditDetails = createAsyncThunk("admin/getOrgCreditDetails", async (thunkAPI) => {
  try {
      setTokenValues();

      const response = await fetch(environment.baseURL +
          apiRoute +
          "/getOrgCreditDetails",
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getMentorAvailableDates = createAsyncThunk("admin/getMentorAvailableDates", async ({userId, date, programId} ,thunkAPI) => {
  try {
      setTokenValues();
    const ate = date ?? "";
      const response = await fetch(environment.baseURL +
          apiRoute +
          "/" +
          userId + 
          `/getMentorAvailableDates?date=${ate}` ,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getMentorSlotsByDate = createAsyncThunk(
  "admin/getMentorSlotsByDate",
  async ({userId, date, programId}, thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/" +
          userId +
          "/getMentorSlotsByDate/" +
          date ,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getFeedbackAnswers = createAsyncThunk(
  "admin/getFeedbackAnswers",
  async (bookingId ,thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "booking/" +
          bookingId +
          "/getFeedbackAnswers" ,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          }
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const addUsersByCsv = createAsyncThunk(
  "admin/addUsersByCsv",
  async ({programId, user, file} ,thunkAPI) => {
    try {

      setTokenValues();
      let formData = new FormData();
      formData.append("file",file);

      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/" +
          programId +
          "/addUsersByCsv/" +
          user ,
        {
          method: "POST",
          headers: {
            // Accept: "application/json",
            // "Content-Type": "application/json",
            Authorization: token
          },
          body: formData
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const addMentorAvailableSlots = createAsyncThunk("admin/addMentorAvailableSlots", async (obj, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "/" +
          obj.programId +
          "/" +
          obj.mentorId +
          "/addMentorAvailableSlots",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify(obj)
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const addMenteeCredits = createAsyncThunk("admin/addMenteeCredits", async ({userId, credits}, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "/addMenteeCredits/" +
          userId ,
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify({credits})
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const addMultipleCredits = createAsyncThunk("admin/addMultipleCredits", async (obj, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "/addMultipleCredits" ,
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify(obj)
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const deleteMentorInterviewSlot = createAsyncThunk("admin/deleteMentorInterviewSlot", async (slotId, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "/" +
          slotId +
          "/deleteMentorInterviewSlot",
          {
              method: "DELETE",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              }
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const deleteUser = createAsyncThunk("admin/deleteUser", async (userId, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "/" +
          userId +
          "/deleteUser",
          {
              method: "DELETE",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              }
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const changePassword = createAsyncThunk(
  "admin/changePassword",
  async (obj, thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "changePassword",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(obj),
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getOrgDetails = createAsyncThunk(
  "admin/getOrgDetails",
  async (thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/getOrgDetails",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          }
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// export const getInterestsAndTopics = createAsyncThunk(
//   "admin/getInterestsAndTopics",
//   async ( programId, thunkAPI) => {
//     try {
//       setTokenValues();
//       const response = await fetch(
//           environment.baseURL + 
//           apiRoute +
//           programId +
//           "/getInterestsAndTopics",
//         {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: token,
//           }
//         }
//       );
//       let data = await response.json();
//       if (response.statusText === 'Unauthorized') {
//             localStorage.clear();
//             window.location.reload();
//         }
      
//       if (response.status === 200) {
//         return data?.Data;
//       } else {
//         return thunkAPI.rejectWithValue(data);
//       }
//     } catch (e) {
//       thunkAPI.rejectWithValue(e.response.data);
//     }
//   }
// );

export const getInterestsByProgram = createAsyncThunk(
  "admin/getInterestsByProgram",
  async ( programs, thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "getInterestsByProgram",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(programs)
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateOrgDetails = createAsyncThunk(
  "admin/updateOrgDetails",
  async (obj, thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "/updateOrgDetails",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(obj),
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const rejectMentorRequest = createAsyncThunk(
  "admin/rejectMentorRequest",
  async ( userId, thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          userId +
          "/rejectMentorRequest",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const acceptMentorRequest = createAsyncThunk(
  "admin/acceptMentorRequest",
  async (userId, thunkAPI) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          userId +
          "/acceptMentorRequest",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllMentorRequests = createAsyncThunk("admin/getAllMentorRequests", async ({search, date, program, status, index},thunkAPI) => {
  try {
      setTokenValues();
      const title = search ?? "";
      const ate = date ?? "";
      const pid = program ?? "";
      const ss = status ?? "";
      const page = index ?? "";

      const response = await fetch(environment.baseURL +
          apiRoute +
          programId +
          `/getAllMentorRequests?title=${title}&pid=${pid}&ate=${ate}&ss=${ss}&page=${page}`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data?.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const getAllEvents = createAsyncThunk(
  "admin/getAllEvents",
  async ( { search, index }, thunkAPI) => {
    try {
      setTokenValues();

      const title = search ?? "";
      const page = index ?? "";

      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          `getAllEvents?page=${page}&title=${title}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllEventRegistrations = createAsyncThunk(
  "admin/getAllEventRegistrations",
  async ( { eventId, search, index } ,thunkAPI ) => {
    try {
      setTokenValues();

      const title = search ?? "";
      const page = index ?? "";

      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          eventId +
          `/getAllEventRegistrations?page=${page}&title=${title}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getDashBoardAdmin = createAsyncThunk(
  "admin/getDashBoardAdmin",
  async ( {duration, month, week }, thunkAPI ) => {
    try {
      setTokenValues();
      
      const dur = duration ?? "";
      const mon = month ?? "";
      const wk = week ?? "";

      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          `/getDashBoardAdmin?dur=${dur}&mon=${mon}&wk=${wk}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getTopRatedMentors = createAsyncThunk(
  "admin/getTopRatedMentors",
  async ( thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getTopRatedMentors",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const notifyUser = createAsyncThunk(
  "admin/notifyUser",
  async ( { bookingId, userId }, thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          bookingId +
          "/" +
          userId +
          "/notifyUser",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const getMentorCallsActivity = createAsyncThunk(
  "admin/getMentorCallsActivity",
  async ( userId , thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getMentorCallsActivity/" +
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMentorPerformance = createAsyncThunk(
  "admin/getMentorPerformance",
  async ( userId , thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getMentorPerformance/" +
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMenteeCallsActivity = createAsyncThunk(
  "admin/getMenteeCallsActivity",
  async ( userId , thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getMenteeCallsActivity/" +
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMenteePerformance = createAsyncThunk(
  "admin/getMenteePerformance",
  async ( userId , thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getMenteePerformance/" +
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const adminSlice = createSlice({
  name: "admin",
  initialState: {
    isFetching: false,
    isEventsFetching: false,
    isLoaderFetching: false,
    isSlotsFetching: false,
    isSlotDatesFetching: false,
    userDataFetching: false,
    isCreditsFetching: false,
    isProgramFetching: false,
    isDashboardFetching: false,
    isUserDashboardFetching: false,
    isUpcomingFetching: false,
    isOngoingFetching: false,
    isPastFetching: false,
    isTopRatedMentorFetching: false,
    isMentorFetching: false,
    isMenteeFetching: false,
    isRequestsFetching: false,
    isSuccess: false,
    isUserNotified: false,
    isUserAddedSuccess: false,
    isError: false,
    errorMessage: "",
    allOrganizations: [],
    allMentors: [],
    allMentees: [],
    particularUser: [],
    programDetails: [],
    dashboardData: [],
    topMentorRatings: [],
    allUpcomingCalls: [],
    allPastCalls: [],
    allOngoingCalls: [],
    userUpcomingCalls: [],
    userPastCalls: [],
    creditDetails: [],
    mentorSlotDates: [],
    mentorSlots: [],
    feedback: [],
    csvResponse: [],
    organizationDetails: [],
    mentorRequests: [],
    events: [],
    eventDetails: [],
    mentorCallsData: [],
    mentorPerformance: [],
    menteeCallsData: [],
    menteePerformance: [],
    interestTopics: [],
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.errorMessage = "";
      state.isSuccess = false;
      state.isUserNotified = false;
      state.isFetching = false;
      state.isEventsFetching = false;
      state.isLoaderFetching = false;
      state.isSlotsFetching = false;
      state.isSlotDatesFetching = false;
      state.userDataFetching = false;
      state.isProgramFetching = false;
      state.isCreditsFetching = false;
      state.isDashboardFetching = false;
      state.isUserDashboardFetching = false;
      state.isUpcomingFetching = false;
      state.isOngoingFetching = false;
      state.isPastFetching = false;
      state.isTopRatedMentorFetching = false;
      state.isMentorFetching = false;
      state.isMenteeFetching = false;
      state.isRequestsFetching = false;
      state.isUserAddedSuccess = false;
      return state;
    },
    clearSlots: (state) => {
      state.mentorSlots = [];
      return state;
    },
    clearUsers: (state) => {
      state.allMentors = [];
      state.allMentees = [];
      state.mentorRequests = [];
      return state;
    },
    clearEvents: (state) => {
      state.events = [];
      state.eventDetails = [];
      return state;
    },
    clearData: (state) => {
      state.mentorCallsData = [];
      state.mentorPerformance = [];
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPrograms.pending, (state) => {
        state.isProgramFetching = true;
    });
    builder.addCase(getAllPrograms.fulfilled, (state, { payload }) => {
        state.isProgramFetching = false;
        state.allPrograms = payload;
    });
    builder.addCase(getAllPrograms.rejected, (state, {payload}) => {
        state.isProgramFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getProgramDetails.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(getProgramDetails.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.programDetails = payload;
    });
    builder.addCase(getProgramDetails.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    // builder.addCase(getDashboardData.pending, (state) => {
    //     state.isFetching = true;
    // });
    // builder.addCase(getDashboardData.fulfilled, (state, { payload }) => {
    //     state.isFetching = false;
    //     state.dashboardData = payload;
    // });
    // builder.addCase(getDashboardData.rejected, (state, {payload}) => {
    //     state.isFetching = false;
    //     state.isError = true;
    //     state.errorMessage = payload?.Message ?? "Something went wrong!";
    // });
    builder.addCase(getAllMentors.pending, (state) => {
        state.isMentorFetching = true;
    });
    builder.addCase(getAllMentors.fulfilled, (state, { payload }) => {
        state.isMentorFetching = false;
        state.allMentors = payload;
    });
    builder.addCase(getAllMentors.rejected, (state, {payload}) => {
        state.isMentorFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllMentees.pending, (state) => {
        state.isMenteeFetching = true;
    });
    builder.addCase(getAllMentees.fulfilled, (state, { payload }) => {
        state.isMenteeFetching = false;
        state.allMentees = payload;
    });
    builder.addCase(getAllMentees.rejected, (state, {payload}) => {
        state.isMenteeFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getParticularUser.pending, (state) => {
        state.userDataFetching = true;
    });
    builder.addCase(getParticularUser.fulfilled, (state, { payload }) => {
        state.userDataFetching = false;
        state.particularUser = payload;
    });
    builder.addCase(getParticularUser.rejected, (state, {payload}) => {
        state.userDataFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllUpcomingCalls.pending, (state) => {
        state.isUpcomingFetching = true;
    });
    builder.addCase(getAllUpcomingCalls.fulfilled, (state, { payload }) => {
        state.isUpcomingFetching = false;
        state.allUpcomingCalls = payload;
    });
    builder.addCase(getAllUpcomingCalls.rejected, (state, {payload}) => {
        state.isUpcomingFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllPastCalls.pending, (state) => {
        state.isPastFetching = true;
    });
    builder.addCase(getAllPastCalls.fulfilled, (state, { payload }) => {
        state.isPastFetching = false;
        state.allPastCalls = payload;
    });
    builder.addCase(getAllPastCalls.rejected, (state, {payload}) => {
        state.isPastFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllOngoingCalls.pending, (state) => {
        state.isOngoingFetching = true;
    });
    builder.addCase(getAllOngoingCalls.fulfilled, (state, { payload }) => {
        state.isOngoingFetching = false;
        state.allOngoingCalls = payload;
    });
    builder.addCase(getAllOngoingCalls.rejected, (state, {payload}) => {
        state.isOngoingFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getUpcomingInterviewDetails.pending, (state) => {
        state.isCallsFetching = true;
    });
    builder.addCase(getUpcomingInterviewDetails.fulfilled, (state, { payload }) => {
        state.isCallsFetching = false;
        state.userUpcomingCalls = payload;
    });
    builder.addCase(getUpcomingInterviewDetails.rejected, (state, {payload}) => {
        state.isCallsFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getPastInterviewDetails.pending, (state) => {
        state.isCallsFetching = true;
    });
    builder.addCase(getPastInterviewDetails.fulfilled, (state, { payload }) => {
        state.isCallsFetching = false;
        state.userPastCalls = payload;
    });
    builder.addCase(getPastInterviewDetails.rejected, (state, {payload}) => {
        state.isCallsFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getOrgCreditDetails.pending, (state) => {
        state.isCreditsFetching = true;
    });
    builder.addCase(getOrgCreditDetails.fulfilled, (state, { payload }) => {
        state.isCreditsFetching = false;
        state.creditDetails = payload;
    });
    builder.addCase(getOrgCreditDetails.rejected, (state, {payload}) => {
        state.isCreditsFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getFeedbackAnswers.pending, (state) => {
        state.isLoaderFetching = true;
    });
    builder.addCase(getFeedbackAnswers.fulfilled, (state, { payload }) => {
        state.isLoaderFetching = false;
        state.feedback = payload;
    });
    builder.addCase(getFeedbackAnswers.rejected, (state, {payload}) => {
        state.isLoaderFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getMentorAvailableDates.pending, (state) => {
        state.isSlotDatesFetching = true;
    });
    builder.addCase(getMentorAvailableDates.fulfilled, (state, { payload }) => {
        state.isSlotDatesFetching = false;
        state.mentorSlotDates = payload;
    });
    builder.addCase(getMentorAvailableDates.rejected, (state, {payload}) => {
        state.isSlotDatesFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getMentorSlotsByDate.pending, (state) => {
        state.isSlotsFetching = true;
    });
    builder.addCase(getMentorSlotsByDate.fulfilled, (state, { payload }) => {
        state.isSlotsFetching = false;
        state.mentorSlots = payload;
    });
    builder.addCase(getMentorSlotsByDate.rejected, (state, {payload}) => {
        state.isSlotsFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(updateUserDetails.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(updateUserDetails.fulfilled, (state) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(updateUserDetails.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(updateSpecificUser.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(updateSpecificUser.fulfilled, (state) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(updateSpecificUser.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(addProgramAndUsers.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(addProgramAndUsers.fulfilled, (state) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(addProgramAndUsers.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(addUser.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(addUser.fulfilled, (state) => {
        state.isFetching = false;
        state.isUserAddedSuccess = true;
    });
    builder.addCase(addUser.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(addMentorAvailableSlots.pending, (state) => {
        state.isLoaderFetching = true;
    });
    builder.addCase(addMentorAvailableSlots.fulfilled, (state) => {
        state.isLoaderFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(addMentorAvailableSlots.rejected, (state, {payload}) => {
        state.isLoaderFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(addMenteeCredits.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(addMenteeCredits.fulfilled, (state) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(addMenteeCredits.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(addMultipleCredits.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(addMultipleCredits.fulfilled, (state) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(addMultipleCredits.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(deleteMentorInterviewSlot.pending, (state) => {
        state.isLoaderFetching = true;
    });
    builder.addCase(deleteMentorInterviewSlot.fulfilled, (state) => {
        state.isLoaderFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(deleteMentorInterviewSlot.rejected, (state, {payload}) => {
        state.isLoaderFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(deleteUser.pending, (state) => {
        state.isLoaderFetching = true;
    });
    builder.addCase(deleteUser.fulfilled, (state) => {
        state.isLoaderFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(deleteUser.rejected, (state, {payload}) => {
        state.isLoaderFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(changePassword.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(changePassword.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(changePassword.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(addUsersByCsv.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(addUsersByCsv.fulfilled, (state, {payload}) => {
        state.isFetching = false;
        state.isSuccess = true;
        state.csvResponse = payload;
    });
    builder.addCase(addUsersByCsv.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getOrgDetails.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getOrgDetails.fulfilled, (state, {payload}) => {
        state.isFetching = false;
        state.organizationDetails = payload;
    });
    builder.addCase(getOrgDetails.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    // builder.addCase(getInterestsAndTopics.pending, (state) => {
    //   state.isFetching = true;
    // });
    // builder.addCase(getInterestsAndTopics.fulfilled, (state, {payload}) => {
    //     state.isFetching = false;
    //     state.interestTopics = payload;
    // });
    // builder.addCase(getInterestsAndTopics.rejected, (state, {payload}) => {
    //     state.isFetching = false;
    //     state.isError = true;
    //     state.errorMessage = payload?.Message ?? "Something went wrong!";
    // });
    builder.addCase(getInterestsByProgram.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getInterestsByProgram.fulfilled, (state, {payload}) => {
        state.isFetching = false;
        state.interestTopics = payload;
    });
    builder.addCase(getInterestsByProgram.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllMentorRequests.pending, (state) => {
        state.isRequestsFetching = true;
    });
    builder.addCase(getAllMentorRequests.fulfilled, (state, {payload}) => {
        state.isRequestsFetching = false;
        state.mentorRequests = payload ?? [];
    });
    builder.addCase(getAllMentorRequests.rejected, (state, {payload}) => {
        state.isRequestsFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(updateOrgDetails.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(updateOrgDetails.fulfilled, (state) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(updateOrgDetails.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(rejectMentorRequest.pending, (state) => {
      state.isLoaderFetching = true;
    });
    builder.addCase(rejectMentorRequest.fulfilled, (state) => {
        state.isLoaderFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(rejectMentorRequest.rejected, (state, {payload}) => {
        state.isLoaderFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(acceptMentorRequest.pending, (state) => {
      state.isLoaderFetching = true;
    });
    builder.addCase(acceptMentorRequest.fulfilled, (state) => {
        state.isLoaderFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(acceptMentorRequest.rejected, (state, {payload}) => {
        state.isLoaderFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllEvents.pending, (state) => {
      state.isEventsFetching = true;
    });
    builder.addCase(getAllEvents.fulfilled, (state, { payload }) => {
        state.isEventsFetching = false;
        state.events = payload;
    });
    builder.addCase(getAllEvents.rejected, (state, {payload}) => {
        state.isEventsFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getAllEventRegistrations.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getAllEventRegistrations.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.eventDetails = payload;
    });
    builder.addCase(getAllEventRegistrations.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getDashBoardAdmin.pending, (state) => {
      state.isDashboardFetching = true;
    });
    builder.addCase(getDashBoardAdmin.fulfilled, (state, { payload }) => {
        state.isDashboardFetching = false;
        state.dashboardData = payload;
    });
    builder.addCase(getDashBoardAdmin.rejected, (state, {payload}) => {
        state.isDashboardFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getTopRatedMentors.pending, (state) => {
      state.isTopRatedMentorFetching = true;
    });
    builder.addCase(getTopRatedMentors.fulfilled, (state, { payload }) => {
        state.isTopRatedMentorFetching = false;
        state.topMentorRatings = payload;
    });
    builder.addCase(getTopRatedMentors.rejected, (state, {payload}) => {
        state.isTopRatedMentorFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(notifyUser.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(notifyUser.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.isUserNotified = true;
    });
    builder.addCase(notifyUser.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getMentorCallsActivity.pending, (state) => {
      state.isUserDashboardFetching = true;
    });
    builder.addCase(getMentorCallsActivity.fulfilled, (state, { payload }) => {
        state.isUserDashboardFetching = false;
        state.mentorCallsData = payload;
    });
    builder.addCase(getMentorCallsActivity.rejected, (state, {payload}) => {
        state.isUserDashboardFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getMentorPerformance.pending, (state) => {
      state.isUserDashboardFetching = true;
    });
    builder.addCase(getMentorPerformance.fulfilled, (state, { payload }) => {
        state.isUserDashboardFetching = false;
        state.mentorPerformance = payload;
    });
    builder.addCase(getMentorPerformance.rejected, (state, {payload}) => {
        state.isUserDashboardFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getMenteeCallsActivity.pending, (state) => {
      state.isUserDashboardFetching = true;
    });
    builder.addCase(getMenteeCallsActivity.fulfilled, (state, { payload }) => {
        state.isUserDashboardFetching = false;
        state.menteeCallsData = payload;
    });
    builder.addCase(getMenteeCallsActivity.rejected, (state, {payload}) => {
        state.isUserDashboardFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getMenteePerformance.pending, (state) => {
      state.isUserDashboardFetching = true;
    });
    builder.addCase(getMenteePerformance.fulfilled, (state, { payload }) => {
        state.isUserDashboardFetching = false;
        state.menteePerformance = payload;
    });
    builder.addCase(getMenteePerformance.rejected, (state, {payload}) => {
        state.isUserDashboardFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
  },
});


export const { clearState } = adminSlice.actions;
export const { clearSlots } = adminSlice.actions;
export const { clearUsers } = adminSlice.actions;
export const { clearEvents } = adminSlice.actions;
export const { clearData } = adminSlice.actions;

export const adminData = (state) => state.admin;